import { get, post } from '../actions/method';
import noti from '../actions/toast';
import helper from '../utils/helper';
import moment from 'moment';

export const exportAudit = async (format, queryObj) => {
  const params = {
    responseType: 'blob',
  };
  return await get(
    `app/audits/export/${format}${helper.compileQueryString(queryObj)}`,
    params,
  )
    .then((resp) => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `AuditRecords-${moment().format('MM-DD-YYYY')}.${format}`,
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch((err) => console.log(err));
};

export default { exportAudit };
